<template>
	<div>
		<performance-review-template-editor :is-admin="loggedInEmployee.isAdmin" :is-saving="isSaving" title="New Template" @save="onSave" @cancel="onCancel" />
	</div>
</template>

<script>
	import PerformanceReviewTemplateEditor from '@/components/performanceReview/PerformanceReviewTemplateEditor';
	import { mapGetters } from 'vuex';

	export default {
		data() {
			return {
				isSaving: false
			};
		},
		components: {
			PerformanceReviewTemplateEditor
		},
		created() {
			this.$store.dispatch('setPageTitle', 'New Template');
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			})
		},
		methods: {
			onSave(template) {
				this.isSaving = true;
				this.$store.dispatch('performanceReviewTemplates/add', template).then(
					response => {
						this.isSaving = false;
						this.$router.push(`/prTemplates/`);
					},
					error => {
						this.isSaving = false;
						console.error('Error saving Template');
					}
				);
			},
			onCancel() {
				window.history.back();
			}
		}
	};
</script>

<style></style>
